"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.options = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactPlayer = _interopRequireDefault(require("react-player"));

var _get = _interopRequireDefault(require("lodash/get"));

var _throttle = _interopRequireDefault(require("lodash/throttle"));

var _reactUseragent = require("@quentin-sommer/react-useragent");

var _utils = require("./utils");

var _getVideoId2 = _interopRequireDefault(require("get-video-id"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var options = {};
exports.options = options;

var factory = function factory(_ref) {
  var identifier = _ref.identifier,
      CtaArea = _ref.CtaArea,
      DesktopPlayer = _ref.DesktopPlayer,
      MobilePlayer = _ref.MobilePlayer,
      VideoPreview = _ref.VideoPreview;

  var Webinar = /*#__PURE__*/function (_React$Component) {
    _inherits(Webinar, _React$Component);

    var _super = _createSuper(Webinar);

    function Webinar(props) {
      var _this;

      _classCallCheck(this, Webinar);

      _this = _super.call(this, props);

      _defineProperty(_assertThisInitialized(_this), "fetchVideoDetails", function () {
        var videoUrl = _this.props.videoUrl;

        var _getVideoId = (0, _getVideoId2["default"])(videoUrl),
            service = _getVideoId.service,
            id = _getVideoId.id;

        if (service === 'youtube') return _this.fetchYoutubeDetails(id);
        if (service === 'vimeo') return _this.fetchVimeoDetails(id);
      });

      _defineProperty(_assertThisInitialized(_this), "fetchYoutubeDetails", function (videoId) {
        return fetch("https://www.googleapis.com/youtube/v3/videos?id=".concat(videoId, "&key=").concat(process.env.YOUTUBE_API_KEY, "&part=player,snippet,contentDetails&maxWidth=").concat(window.innerWidth)).then(function (res) {
          return res.json();
        }).then(function (data) {
          console.log('fetchYoutubeDetails');
          var thumbnail = (0, _utils.getThumbnail)((0, _get["default"])(data, 'items[0]', {}));
          var duration = (0, _get["default"])(data, 'items[0].contentDetails.duration');
          var durationInS = (0, _utils.durationToSeconds)(duration);
          var width = (0, _get["default"])(data, 'items[0].player.embedWidth', 1280);
          var height = (0, _get["default"])(data, 'items[0].player.embedHeight', 720);
          var ratio = 100 / (width / height);

          _this.setState({
            videoDuration: durationInS,
            thumbnail: thumbnail,
            ratio: ratio
          });
        });
      });

      _defineProperty(_assertThisInitialized(_this), "fetchVimeoDetails", function (videoId) {
        return fetch("https://vimeo.com/api/oembed.json?url=https://vimeo.com/".concat(videoId)).then(function (res) {
          return res.json();
        }).then(function (data) {
          var thumbnail = data.thumbnail_url;
          var duration = data.duration;
          var durationInS = duration / 1000;
          var width = (0, _get["default"])(data, 'width', 1280);
          var height = (0, _get["default"])(data, 'height', 720);
          var ratio = 100 / (width / height);

          _this.setState({
            videoDuration: durationInS,
            thumbnail: thumbnail,
            ratio: ratio
          });
        });
      });

      _defineProperty(_assertThisInitialized(_this), "showCTA", function () {
        _this.setState({
          ctaVisible: true
        });
      });

      _defineProperty(_assertThisInitialized(_this), "handlePause", function () {
        _this.setState({
          playing: false
        });
      });

      _defineProperty(_assertThisInitialized(_this), "handlePlay", function () {
        _this.setState({
          playing: true
        });
      });

      _defineProperty(_assertThisInitialized(_this), "handleCtaClick", function () {
        var clickHandler = _this.props.clickHandler;
        if (clickHandler) clickHandler();

        _this.handlePause();
      });

      _defineProperty(_assertThisInitialized(_this), "handleFullscreenChange", function (isFull) {
        _this.setState({
          playing: isFull
        });
      });

      _defineProperty(_assertThisInitialized(_this), "handleProgress", function (_ref2) {
        var playedSeconds = _ref2.playedSeconds;

        _this.throttledCheckCtaVisibility(playedSeconds);
      });

      _defineProperty(_assertThisInitialized(_this), "checkCtaVisibility", function (time) {
        var durationTrigger = _this.props.durationTrigger;
        if (time >= durationTrigger) return _this.showCTA();
      });

      _defineProperty(_assertThisInitialized(_this), "throttledCheckCtaVisibility", (0, _throttle["default"])(_this.checkCtaVisibility, 1000));

      _defineProperty(_assertThisInitialized(_this), "renderPlayer", function () {
        var videoUrl = _this.props.videoUrl;
        return /*#__PURE__*/_react["default"].createElement(_reactPlayer["default"], {
          url: videoUrl,
          playing: _this.state.playing,
          controls: false,
          onProgress: _this.handleProgress,
          className: "react-player",
          width: "100%",
          height: "100%"
        });
      });

      _defineProperty(_assertThisInitialized(_this), "renderDesktop", function () {
        return /*#__PURE__*/_react["default"].createElement(DesktopPlayer, {
          playing: _this.state.playing,
          ctaVisible: _this.state.ctaVisible,
          buttonProps: _this.buttonProps,
          onFullscreenChange: _this.handleFullscreenChange,
          onCloseClick: _this.handlePause,
          onCtaClick: _this.handleCtaClick
        }, _this.renderPlayer());
      });

      _defineProperty(_assertThisInitialized(_this), "renderMobile", function () {
        return /*#__PURE__*/_react["default"].createElement(MobilePlayer, {
          ratio: _this.state.ratio,
          buttonProps: _this.buttonProps,
          playing: _this.state.playing,
          ctaVisible: _this.state.ctaVisible,
          onCloseClick: _this.handlePause,
          onCtaClick: _this.handleCtaClick
        }, _this.renderPlayer());
      });

      _this.state = {
        videoDuration: 0,
        ctaVisible: false,
        playing: false,
        thumbnail: '',
        ratio: 56.2,
        // 16:9
        mounted: false
      };
      return _this;
    }

    _createClass(Webinar, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.fetchVideoDetails();
        this.setState({
          mounted: true
        });
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (prevProps.videoUrl !== this.props.videoUrl) {
          this.fetchVideoDetails();
        }
      }
    }, {
      key: "render",
      value: function render() {
        if (!this.state.mounted) return null;
        var _this$props = this.props,
            theme = _this$props.theme,
            messageText = _this$props.messageText,
            ctaVisible = _this$props.ctaVisible,
            noInteraction = _this$props.noInteraction;
        var wrapperClass = (0, _classnames["default"])(theme.wrapper, _defineProperty({}, theme.noInteraction, noInteraction));
        return /*#__PURE__*/_react["default"].createElement(_reactUseragent.UserAgentProvider, {
          ua: this.userAgent
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: wrapperClass
        }, !this.state.playing && /*#__PURE__*/_react["default"].createElement(VideoPreview, {
          src: this.state.thumbnail,
          onPlayClick: this.handlePlay
        }), /*#__PURE__*/_react["default"].createElement(_reactUseragent.UserAgent, {
          computer: true
        }, this.renderDesktop()), /*#__PURE__*/_react["default"].createElement(_reactUseragent.UserAgent, {
          mobile: true,
          tablet: true
        }, this.renderMobile()), /*#__PURE__*/_react["default"].createElement(CtaArea, {
          buttonProps: this.buttonProps,
          messageText: messageText,
          ctaVisible: this.state.ctaVisible,
          ctaVisibleForced: ctaVisible,
          onCtaClick: this.handleCtaClick
        })));
      }
    }, {
      key: "buttonProps",
      get: function get() {
        var _this$props2 = this.props,
            buttonText = _this$props2.buttonText,
            buttonColor = _this$props2.buttonColor,
            buttonTextColor = _this$props2.buttonTextColor,
            buttonLink = _this$props2.buttonLink;
        return {
          text: buttonText,
          bgColor: buttonColor,
          textColor: buttonTextColor,
          link: buttonLink
        };
      }
    }, {
      key: "userAgent",
      get: function get() {
        if (typeof window !== 'undefined') {
          return window.navigator.userAgent;
        }
      }
    }]);

    return Webinar;
  }(_react["default"].Component);

  Webinar.displayName = identifier;
  Webinar.propTypes = {
    clickHandler: _propTypes["default"].func,
    videoUrl: _propTypes["default"].string.isRequired,
    durationTrigger: _propTypes["default"].number.isRequired,
    buttonText: _propTypes["default"].string.isRequired,
    buttonColor: _propTypes["default"].string,
    buttonTextColor: _propTypes["default"].string,
    buttonLink: _propTypes["default"].string,
    messageText: _propTypes["default"].string.isRequired,
    ctaVisible: _propTypes["default"].bool,
    noInteraction: _propTypes["default"].bool,
    theme: _propTypes["default"].object.isRequired
  };
  return Webinar;
};

var _default = factory;
exports["default"] = _default;